import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const LOGO = "/img/logo-faunny-jinete.png";
export const MASCOT = "https://customer-assets-39nsmqrw.emergentagent.net/job_bienestar-equino/artifacts/0c57989fd3f836d7_IMG_2466.webp";
export const HERO = "https://images.unsplash.com/photo-1648374587721-1ac05e0c6b5b?crop=entropy&cs=srgb&fm=jpg&q=80&w=1800";
export const HORSE_2 = "https://images.unsplash.com/flagged/photo-1568381670226-fab8dc323343?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400";
export const HORSE_3 = "https://images.unsplash.com/photo-1590839823121-c253bf8d1e7d?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400";

export const api = axios.create({ baseURL: `${BACKEND}/api` });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("faunny_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const img = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u);

export const eur = (v) =>
  new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR", useGrouping: "always" }).format(v || 0);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Algo ha fallado. Inténtalo de nuevo.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (/email/i.test(x?.msg || "") ? "El email no es válido." : x?.msg || JSON.stringify(x))).join(" ");
  return String(d);
}

export const LINES = { complementos: "Complementos nutricionales", salud: "Salud e higiene", gear: "FAUNNY Gear" };
export const NEEDS = {
  digestion: "Digestión", articulaciones: "Articulaciones", piel: "Piel", hidratacion: "Hidratación",
  musculo: "Músculo", cascos: "Cascos y crines", calma: "Calma",
};
export const FEATURED_ORDER = ["sand-free", "isotonic", "equi-care", "oil-all-in-one", "joint-condro", "bulk", "power-booster"];

export const STATUS = {
  pendiente_pago: "Pendiente de pago", pagado: "Pagado", enviado: "Enviado", entregado: "Entregado",
  fallido: "Pago fallido", cancelado: "Cancelado",
};
